// src/pages/dashboard/AddProperty.js
import React, { useState, useEffect } from "react";
import { collection, addDoc, serverTimestamp, doc, getDoc } from "firebase/firestore";
import { auth, db } from "../../firebase";
import DashboardLayout from "../../layouts/DashboardLayout";

const AddProperty = () => {
    const [form, setForm] = useState({
        title: "",
        address: "",
        vraagprijs: "",
        aangebodenDoor: "",
        makelaarNaam: "",
        makelaarTel: "",
        makelaarEmail: "",
        makelaarFotoUrl: "",
        woningFotoUrl: "",
    });

    // Haal standaard makelaarsgegevens op uit het profiel
    useEffect(() => {
        const fetchProfile = async () => {
            const user = auth.currentUser;
            if (!user) return;

            const profileRef = doc(db, "users", user.uid);
            const profileSnap = await getDoc(profileRef);
            if (profileSnap.exists()) {
                const profile = profileSnap.data();
                setForm((prev) => ({
                    ...prev,
                    makelaarNaam: `${profile.voornaam || ""} ${profile.achternaam || ""}`.trim(),
                    makelaarTel: profile.telefoon || "",
                    makelaarEmail: profile.email || "",
                    makelaarFotoUrl: profile.profielfotoUrl || "",
                    aangebodenDoor: profile.bedrijf || "", // 👈 voeg dit toe
                }));
            }
        };

        fetchProfile();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const user = auth.currentUser;
        if (!user) return;

        const data = {
            ...form,
            createdAt: serverTimestamp(),
            userId: user.uid,
        };

        await addDoc(collection(db, "properties"), data);
        alert("Woning toegevoegd ✅");
        setForm({
            title: "",
            address: "",
            vraagprijs: "",
            aangebodenDoor: "",
            makelaarNaam: "",
            makelaarTel: "",
            makelaarEmail: "",
            makelaarFotoUrl: "",
            woningFotoUrl: "",
        });
    };

    return (
        <DashboardLayout>
            <div className="max-w-2xl mx-auto">
                <h2 className="text-2xl font-semibold mb-4">Woning toevoegen</h2>

                <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow space-y-4">
                    {/*<input*/}
                    {/*    type="text"*/}
                    {/*    name="title"*/}
                    {/*    placeholder="Titel van de woning"*/}
                    {/*    value={form.title}*/}
                    {/*    onChange={handleChange}*/}
                    {/*    required*/}
                    {/*    className="w-full border rounded px-3 py-2"*/}
                    {/*/>*/}
                    <input
                        type="text"
                        name="address"
                        placeholder="Adres"
                        value={form.address}
                        onChange={handleChange}
                        required
                        className="w-full border rounded px-3 py-2"
                    />

                    <hr className="my-2" />
                    <h3 className="font-medium text-gray-700">Makelaar</h3>

                    <input
                        type="text"
                        name="makelaarNaam"
                        placeholder="Makelaar naam"
                        value={form.makelaarNaam}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                    />
                    <input
                        type="text"
                        name="makelaarTel"
                        placeholder="Telefoonnummer"
                        value={form.makelaarTel}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                    />
                    <input
                        type="email"
                        name="makelaarEmail"
                        placeholder="E-mailadres"
                        value={form.makelaarEmail}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                    />

                    <hr className="my-2" />
                    <h3 className="font-medium text-gray-700">Woninggegevens</h3>

                    <input
                        type="text"
                        name="vraagprijs"
                        placeholder="Vraagprijs (bijv. €269.000 k.k.)"
                        value={form.vraagprijs}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                    />
                    <input
                        type="text"
                        name="aangebodenDoor"
                        placeholder="Aangeboden door"
                        value={form.aangebodenDoor}
                        onChange={(e) => setForm({ ...form, aangebodenDoor: e.target.value })}
                        className="w-full border rounded px-3 py-2"
                    />
                    <input
                        type="url"
                        name="woningFotoUrl"
                        placeholder="URL woningfoto"
                        value={form.woningFotoUrl}
                        onChange={handleChange}
                        className="w-full border rounded px-3 py-2"
                    />

                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white rounded py-2 hover:bg-blue-700 transition"
                    >
                        Woning toevoegen
                    </button>
                </form>
            </div>
        </DashboardLayout>
    );
};

export default AddProperty;
